import { Check, Mail } from "lucide-react";
import { ThemeToggle } from "./ThemeToggle";

export function BrandLockup() {
  return (
    <span className="brand-lockup">
      <span className="brand-mark" aria-hidden="true"><Mail size={15} strokeWidth={2.4} /></span>
      Maildeck
    </span>
  );
}

/** Zweispaltiger Rahmen für Anmeldung — links die Marke, rechts das Formular. */
export function AuthShell({ title, lede, children }: { title: string; lede?: string; children: React.ReactNode }) {
  return (
    <main className="auth">
      <section className="auth-hero">
        <BrandLockup />
        <div>
          <p className="auth-hero-title">Der Posteingang, der sich selbst sortiert.</p>
          <p className="auth-hero-text">
            Regeln zuerst, danach ein Sprachmodell für den Rest. Belege, Spam und Dringendes landen,
            wo sie hingehören — nachvollziehbar und umkehrbar.
          </p>
          <ul className="auth-points">
            <li><Check aria-hidden="true" /> Läuft auf eigener Infrastruktur</li>
            <li><Check aria-hidden="true" /> Jeder Eingriff im Protokoll</li>
            <li><Check aria-hidden="true" /> Zugangsdaten verschlüsselt gespeichert</li>
          </ul>
        </div>
        <p className="auth-copy">© {new Date().getFullYear()} Kreativ Wolke · Maildeck</p>
      </section>

      <section className="auth-main">
        <div className="auth-form">
          <div className="auth-mobile-brand"><BrandLockup /></div>
          <h1>{title}</h1>
          {lede && <p className="lede">{lede}</p>}
          {children}
          <div className="auth-foot">
            <span>Darstellung</span>
            <ThemeToggle />
          </div>
        </div>
      </section>
    </main>
  );
}
